import { render, staticRenderFns } from "./UsersubTableMenu.vue?vue&type=template&id=2b96a9ef&scoped=true&"
import script from "./UsersubTableMenu.vue?vue&type=script&lang=js&"
export * from "./UsersubTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b96a9ef",
  null
  
)

export default component.exports